/**
 * AI CONTEXT: referral-system - Shareable referral link redirect handler
 * Journal: J-20250107-01 (Extended - Shareable Links)
 * 
 * Purpose:
 * - Capture referral code from shareable URLs (e.g., /share/12345678)
 * - Store referral code for registration page
 * - Redirect to registration with pre-populated code
 * 
 * User flow:
 * 1. User receives shareable link from friend
 * 2. Clicks link → lands on /share/{code}
 * 3. Component captures code and stores in localStorage
 * 4. Redirects to /register with code pre-populated
 * 
 * Future considerations:
 * - Add analytics tracking for share link clicks
 * - Show referrer's name/message before redirect
 * - Add social preview metadata
 */

import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader } from 'lucide-react';

const ReferralShare = () => {
  const { referralCode } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // AI CONTEXT: ux - Store referral code for registration form
    // Reasoning: Using localStorage ensures code persists across page navigation
    // Constraints: Code must be validated on backend, frontend just stores it
    // Future: Consider session storage for multi-tab scenarios
    
    if (referralCode) {
      // Store the referral code in localStorage
      localStorage.setItem('pendingReferralCode', referralCode);
      
      // Redirect to registration page after a brief moment
      setTimeout(() => {
        navigate('/register');
      }, 500);
    } else {
      // If no code provided, redirect to home
      navigate('/');
    }
  }, [referralCode, navigate]);

  return (
    <div className="min-h-screen bg-theme-black flex items-center justify-center">
      <div className="text-center">
        <Loader className="h-12 w-12 text-custom-orange animate-spin mx-auto mb-4" />
        <h2 className="text-xl font-bold text-theme-silver mb-2">
          Processing Referral Link...
        </h2>
        <p className="text-theme-silver-light">
          Redirecting you to registration
        </p>
      </div>
    </div>
  );
};

export default ReferralShare;
